<template>
  <VLayout
    class="rounded rounded-md viewport-height-adjusted overflow-x-hidden"
  >
    <TheSidebar v-if="!mobile" />

    <TheHeader />

    <VMain
      class="bg-background h-100 w-100 overflow-hidden"
      :class="{ 'mobile-main-with-bottom-nav': showBottomNavigation }"
      scrollable
    >
      <section :class="[contentSectionClass, 'overflow-hidden']">
        <slot />
      </section>
    </VMain>

    <TheBottomNavigation v-if="showBottomNavigation" />

    <CustomToast v-if="toastStore.messages.length > 0" />

    <NotificationHost />
  </VLayout>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { VLayout, VMain } from 'vuetify/components'
import CustomToast from '../components/shared/CustomToast/CustomToast.vue'
import { useToastStore } from '../store'
import TheSidebar from '@/modules/Core/components/layout/TheSidebar/TheSidebar.vue'
import TheHeader from '@/modules/Core/components/layout/TheHeader/TheHeader.vue'
import TheBottomNavigation from '@/modules/Core/components/layout/TheBottomNavigation/TheBottomNavigation.vue'
import NotificationHost from '@/modules/Notification/components/NotificationHost/NotificationHost.vue'
import { useAuthStore } from '@/modules/Auth/store'
import { useResponsiveLayout } from '@/modules/Core/composables'
import { useCurrentEmployeeProfile } from '@/modules/User/composables/useCurrentEmployeeProfile'

defineOptions({
  name: 'TheDefaultLayout',
})

const route = useRoute()
const authStore = useAuthStore()
const toastStore = useToastStore()
const { mobile } = useResponsiveLayout()

useCurrentEmployeeProfile()

const hideBottomNavOnMobile = computed(
  () => mobile.value && Boolean(route.meta.hideBottomNavOnMobile)
)

const showBottomNavigation = computed(
  () => mobile.value && !hideBottomNavOnMobile.value && !authStore.isApplicant
)

const isContentFlush = computed(
  () => mobile.value && Boolean(route.meta.contentFlushOnMobile)
)

const contentSectionClass = computed(() =>
  isContentFlush.value ? 'ma-0' : 'ma-2 ma-md-5'
)
</script>

<style scoped>
.mobile-main-with-bottom-nav {
  padding-bottom: 72px;
}

:deep(.v-main__wrap) {
  overflow-x: hidden;
}
</style>
